import { RequestMethod } from './_enums'

export interface RequestModel {
  method: RequestMethod
  endpoint: string
  data?: any
  queryObject?: any
  headers?: any
  ifSuccessRedirectTo?: string
  blockFree?: boolean
}

export interface FileModel {
  Nome: string
  Extensao: string
  Tamanho: number
  Tipo: string
  Base64: string
  Url: string
}

export const defaultRequestModel: Partial<RequestModel> = {
  data: null,
  queryObject: null,
  headers: null,
  ifSuccessRedirectTo: '',
}

export interface ISelectModel {
  Id: number
  Nome: string
  Texto?: string
}

export interface JwtTokenModel {
  iss?: string;
  sub?: string;
  aud?: string[] | string;
  roles?: string[];
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
}

export interface IAcaoModel {
  Id: number,
  Nome: string,
}

export interface IFuncionalidadeModel {
  Id: number,
  IdInterface: number,
  IdAcao: number,
  Codigo: string,
  Ativa: boolean,
  Acao: string,
}

export interface IPermissaoModel {
  Id: number,
  IdFuncionalidade: number,
  IdPerfil: number,
  Funcionalidade?: IFuncionalidadeModel,
}

export interface IInterfaceModel {
  Id: number,
  IdAplicacao: number,
  Nome: string,
  Rota: string,
  Icone: string,
  Administrativa: boolean,
  Funcionalidades: IFuncionalidadeModel[],
}

export interface IAplicacaoModel {
  Id: number,
  IdModulo: number,
  Nome: string,
  Url: string,
  Icone: string,
  Interfaces: IInterfaceModel[],
}

export interface IModuloModel {
  Id: number,
  Nome: string,
  Categoria: number,
  CategoriaNome: string,
  Icone: string,
  Aplicacoes: IAplicacaoModel[],
}

export interface IDadosMenuModel {
  Categoria: number,
  CategoriaNome: string,
  Modulos: IModuloModel[],
}

export interface IPerfilModel {
  Id: number,
  Nome: string,
  Permissoes: IPermissaoModel[],
}

export interface IUsuarioModel {
  Id: string,
  Tipo: number,
  Nome: string,
  Email: string,
  Celular: string,
  Senha: string,
  Perfis: number[]
  IdOrganization: number,
}

export interface IGatewaysModel {
  [key: string]: any;
  Alerta: string;
  Alertar?: number;
  IdGateway: number;
  IdOrg: number;
  Corporation: string;
  Gateway: string;
  SerialNumber?: string;
  LastDevicesReadCount?: number;
  Latitude?: number;
  Local: string;
  LocalSituacao: string;
  LocalDescricao?: string;
  Longitude?: number;
  Organizacao: string;
  Organization: string;
  PlaceType: string;
  Status: string;
  Status_revisado: string;
  SystemName: string;
  Temperature?: number;
  TempoDecorrido?: number;
  UltimaAtualizacao: string;
  IdPlace: number;
}

export interface IMqttModel {
  [key: string]: any;
  Ativo: string;
  AtivoDescricao: string;
  Organizacao: string;
  Local: string;
  LocalDescricao: string;
  DeviceId: string;
  TimeStamp: string;
  Rssi: number;
  Distance: number;
  AdvTxPower: number;
  Temp: number | null;
  Bat: number | null;
  Latitude: number | null;
  Longitude: number | null;
  AxisX: number | null;
  AxisY: number | null;
  AxisZ: number | null;
  MacAddress: string;
  Namespace: string;
  TlmAdvCount: number | null;
  TlmTimeSinceBoot: number | null;
  IBeaconuuid: string | null;
  IBeaconMajor: number | null;
  IBeaconMinor: number | null;
  Readerid: string;
  Devices: number;
  Gateway: string;
  LastDevicesReadCount?: number;
  LocalSituacao: string;
  Organization: string;
  PlaceType: string;
  Status: string;
  Status_revisado: string;
  SystemName: string;
  Temperature?: number;
  TempoDecorrido?: number;
  UltimaAtualizacao: string;
  IdPlace: number;
}

export interface ILocaisModel {
  Alerta: string;
  Alertar?: number;
  IdGateway: number;
  IdOrg: number;
  Corporation: string;
  Gateway: string;
  SerialNumber?: string;
  LastDevicesReadCount?: number;
  Latitude?: number;
  Local: string;
  LocalSituacao: string;
  LocalDescricao?: string;
  Longitude?: number;
  Organizacao: string;
  Organization: string;
  PlaceType: string;
  Status: string;
  Status_revisado: string;
  SystemName: string;
  Temperature?: number;
  TempoDecorrido?: number;
  UltimaAtualizacao: string;
  IdPlace: number;
}

export interface IPlaceWorkFlowModel {
  IdWorkFlow: number,
  Chamado: string,
  Assunto: string,
  Dados: string,
  GatewayDescricao: string,
  DataFechamento: string,
  DataCriacao: string,
  DataAlteracao: string,
  Status: boolean,
  UsuarioOwner: string,
  IdUsuarioOwner: number,
  UsuarioResponsible: string,
  IdUsuarioResponsible: number,
  IdOrganization: number,
  IdGateway: number,
  IdPlace: number,
  IdWorkFlowUserClose: number,
  IdAlertLevel: number,
}

export interface IVisaoGeralModel {
  [key: string]: any;
  Alerta: string;
  Alteracao: string;
  Assunto: string;
  Chamado: string;
  Cor: string;
  Descricao: string;
  Fechamento: string;
  IdWorkFlow?: number;
  Inclusao: string;
  Local: string;
  LocalDescricao: string;
  Movel?: number;
  Nome: string;
  Organization: string;
  Origem: string;
  Requisitante: string;
  Responsavel: string;
  Situacao?: number;
  Status: string;
  TempoDecorrido?: number;
  TimeToResolve_minutes?: number;
  TotalInteracoes?: number;
  UltimaAtualizacao: string;
  UltimaInteracao: string;
  UltimoComentarioUsuario: string;
}

export interface IAtivosModel {
  [key: string]: any;
  Alerta: string | null;
  Alertar?: number | null;
  Ativo: string;
  AtivoSituacao: string;
  Descricao: string;
  Gateway: string | null;
  Status: string;
  IdBeacon: string;
  Latitude?: number | null;
  Local: string | null;
  Longitude?: number | null;
  MinutosDeAlerta?: number | null;
  Organizacao: string;
  PlaceType: string;
  StatusGateway: string;
  TempoDecorrido?: number | null;
  IdAtivo: number;
  IdPrism: number;
  IdOrganization: number;
  UltimaVisualizacao?: string | null;
  TempoDeCarencia: number;
  LocalDescricao: string | null;
  Temperatura?: number | null;
  Bateria: number;
  OrgLocal: string | null;
  IdOrgDoLocal?: number | null;
  CorpLocal: string | null;
  IdPrismAlerts: number;
  Corporacao: string;
  IdOrganizacao: number;
  IdGateway: number | null;
  Distance?: number | null;
  DeviceId: string | null;
  Associacao: string | null;
  LatLongOrigin: string | null;
  LastlatLongOrigin?: string | null;
  Organizacao2?: string;
  Medida?: number;
  TempoDecorridoDaysHoursMins?: string;
  associatedIcon?: {
        IdPrism: number;
        Codigo: string;
        Name: string;
        Description: string;
        Value: {
            SVG?: string;
            Class?: string;
        }
    } | null;
  relacionados?: IAtivosModel[];
}
export interface IMovimentacaoModel {
  Organizacao: string;
  LocalTipo: string;
  Local: string;
  timestampIni: string;
  timestampEnd: string;
  idAtivo: number;
  Ativo: string | null;
  AtivoTipo: string | null;
  DistanciaAtivo: number;
  Latitude: number;
  Longitude: number;
  LongIniAtivo: number;
  LatIniAtivo: number;
  LongFimAtivo: number;
  LatFimAtivo: number;
  DistJanelasAtivo: number;
  DirecaoAtivo: string | null;
  AxisZAtivo: string | null;
}

export interface IPlaceWorkFlowUserModel {
  Id: number
  IdUser: number
  NameUser: string,
  IdPlaceWorkFlow: number,
  Comments: string,
  DtCriacao: string,
  DtAlteracao: string,
  Name: string,
}